import React from 'react';
import './style.scss';
import { noop } from 'lodash';

/**
 * FormItem component - a box with border to add other components.
 *
 * @param {Object} props - Props for the FormItem component.
 * @param {string} props.label - The label for the form item.
 * @param {string} props.isResponsible - Indicates if it's responsible Page: that affects the label background color.
 * @param {React.ReactNode} props.children - The children elements.
 * @returns {JSX.Element} The FormItem component.
 */
function FormItem({ label, children, isResponsible }) {
    return (
        <div className="form-item" data-title={label}>
            <label className={`${isResponsible && "is-responsible"}`}>{label}</label>
            {children}
        </div>
    );
}

FormItem.defaultProps = {
    label: '',
    children: noop,
    isResponsible: false,
};

export default FormItem;
